import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { tenancySchedulePrintLayoutCss } from './tenancy-schedule-print-layout.css';
import { Subject } from 'rxjs';
import { ColumnFormatterService } from '@feature/common/services/column-formatter.service';
import { ColumnDefinitionFormatType as FormatType } from '@feature/common/enums/column-definition-format-type';

@Component({
  selector: 'mojo-tenancy-schedule-print-layout',
  templateUrl: './tenancy-schedule-print-layout.component.html'
})
export class TenancySchedulePrintLayoutComponent implements OnChanges, OnDestroy {
  @Input() printData: any;
  @Input() footerValues: any;
  @Input() context: any;
  @Input() headCss: string[] = [tenancySchedulePrintLayoutCss];
  @Input() displayHeader: boolean = false;
  private destroy$ = new Subject<void>();
  private readonly COLUMNS_PER_PAGE = 14;
  public pages: any[] = [];

  constructor(
    private columnFormatterService: ColumnFormatterService
  ) {}


  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.printData && this.printData?.Columns) {
      this.splitColumnsIntoPages();
      this.forceUpdate();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  private splitColumnsIntoPages(): void {
    const columns = this.printData?.Columns || [];
    const totalColumns = columns.length;
    const pagesCount = Math.ceil(totalColumns / this.COLUMNS_PER_PAGE);

    this.pages = [];
    for (let i = 0; i < pagesCount; i++) {
      const start = i * this.COLUMNS_PER_PAGE;
      const end = Math.min(start + this.COLUMNS_PER_PAGE, totalColumns);
      this.pages.push({
        columns: columns.slice(start, end),
        pageNumber: i + 1,
        totalPages: pagesCount
      });
    }
  }

  private forceUpdate() {
    this.printData = { ...this.printData };
  }

  get entityInfoValue() {
    return this.printData?.entityInfo || null;
  }

  get widgetName(): string {
    return 'Tenancy Schedule';
  }


  get dataRows(): any[] {
    return this.printData?.Rows || [];
  }

  formatByColumnType(rowData: any, columnType: number): string {
    if (columnType === FormatType.Currency) {
      return this.columnFormatterService.formatByType(rowData, FormatType.Numeric2Dp);
    }
    return this.columnFormatterService.formatByType(rowData, columnType);
  }

  isLeftAlignedColumn(columnType: number): boolean {
    return !this.isRightAlignedColumn(columnType) && !this.isCenteredColumn(columnType);
  }

  isRightAlignedColumn(columnType: number): boolean {
    return (columnType === FormatType.Currency || columnType === FormatType.Numeric2Dp || columnType === FormatType.Numeric0Dp);
  }

  isCenteredColumn(columnType: number): boolean {
    return columnType === FormatType.Date
  }

  now(): Date {
    return new Date();
  }
}
